import { render, staticRenderFns } from "./communityDataStatistics.vue?vue&type=template&id=5153df6f&"
import script from "./communityDataStatistics.vue?vue&type=script&lang=js&"
export * from "./communityDataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./communityDataStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports